/** Keys into `stepsStatus` — one per `Section` */
export const MULTIPLIER_STEPS = {
  DETAILS: 'DETAILS',
  SCHEDULE: 'SCHEDULE',
  ELIGIBLE_PRODUCTS: 'ELIGIBLE_PRODUCTS'
} as const

/** The multiplier factor Select's options — whole numbers 2 to 10, defaulting to 2 */
export const FACTOR_OPTIONS = Array.from({ length: 9 }, (_, i) => i + 2)

export const DEFAULT_FACTOR = 2

export const NAME_MAX = 30
export const DESCRIPTION_MAX = 100

export const MULTIPLIERS_LIST_PATH = '/loyalty/bonuses-and-multipliers'

export const MULTIPLIER_NAV = {
  afterCreate: MULTIPLIERS_LIST_PATH,
  afterUpdate: MULTIPLIERS_LIST_PATH,
  cancel: MULTIPLIERS_LIST_PATH
}

/** How dates are typed and shown across the form and its summary */
export const DATE_FORMAT = 'DD/MM/YYYY'
